// export const BASE_URL ="https://nmcfcs90-5000.inc1.devtunnels.ms/api" ;
export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const ENDPOINTS = {
  users: "/users",
  missions: "/missions",
  auth: {
    login: "/auth/login",
    logout: "/auth/logout",
    refresh: "/auth/refresh",
    forgotPassword: "/auth/forgot-password",
    resendOtp: "/auth/resend-otp",
    verifyOtp: "/auth/verify-otp",
    resetPassword: "/auth/reset-password",
  },
  cms: {
    create: (section) => `/dashboard/cms/create/${section}`,
    getDetails: "/dashboard/cms",
  },
  marketing: {
    createCampaign: "/marketing-campaign",
    analytics: "/marketing-campaign/analytics",
    activityLogs: "/marketing-campaign/activity-logs",
    admins: "/marketing-campaign/admins",
    adminById: (id) => `/marketing-campaign/${id}`,
    getDetails: (id) => `/marketing-campaign/${id}`,
    getAnalyticsById: (id) => `/marketing-campaign/${id}/analytics`,
    deleteCampaign: (id) => `/marketing-campaign/${id}`,
  },
  usermanagement: {
    allUser: "/user-management/ALLusers",
    updateUser: (id) => `/user-management/${id}`,
    userAction: (id, action) =>
      `/user-management/${id}/action?action=${action}`,
    adjustDistance: "/user-management/adjust-distance",
    userChallenges: (userId) => `/admin/challenges/user/${userId}`,
  },

  moreInfoSupport: {
    terms: "/cms/terms-and-conditions",
    privacy: "/cms/privacy-policy",
    about: "/cms/about-us/upsert",
    faq: "/cms/faqs",
  },
  teams: {
    create: (id) => `/challenge-team/add-team-member/${id}`,
    getAllDetails: "/challenge-team/all-teams",
    getDetails: (id) => `/challenge-team/view/team-details/${id}`,
    removeMember: (userId, teamId) =>
      `/challenge-team/remove-team-member/${userId}/${teamId}`,
  },
  report:{
    Details: "/admin/admin-dashboard",
  },
  dispute: {
    create: `/admin/create-dispute`,
    list: `/admin/disputes`,
    getDetails: (id) => `/admin/disputes/${id}`,
    update: (id) => `/admin/update-dispute/${id}`,
    resolve: (id) => `/admin/resolve-dispute/${id}`,
    auditLog: () => `/admin/audit-logs`,
  },
  dashboard: {
    getDetails: "/admin/dashboard",
  },
  payment: {
    getDetails: "/admin/financials-transactions",
    refund: (orderId) => `/stripe/refund/${orderId}`,
    receipt: (orderId) => `/admin/payment-receipt/${orderId}`,
  },
  profile: {
    changePassword: "/profile/me/change-password",
    getDetail: "/profile/me",
    update: "/profile/me/profile-detail",
    updateImage: "/profile/me/profile-image",
    getSessions: "/auth/session",
  },
  community: {
    getCommunity: "/community/record",
    saveCommunity: "/community/record",
  },
  notifications:{
    latest:"/notifications/latest",
    viewAll:"/notifications/view-all",
    markAllRead:"/notifications/mark-all-read",
  }

};
